<template>
  <!-- Conteúdo Principal -->
  <div class="flex-1 p-6 ml-4 lg:ml-64 pb-0">
    <!-- Header -->
    <Header
      @company-selected="handleCompanySelected"
      @update-controllers-count="updateControllersCount"
      class="text-sm sm:text-base lg:text-lg"
    />
    <!-- Main Dashboard Content -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pl-2.5">
      <!-- Card Controles -->
      <div
        class="flex flex-col p-2 mb-2 rounded-lg shadow-xl col-span-1 lg:col-span-3"
      >
        <Card class="text-sm sm:text-base lg:text-lg" v-bind="computedProps" />
      </div>
      <div class="flex w-full h-150 space-x-4 col-span-1 lg:col-span-3 mt-2">
        <!-- Gráfico de Barra Grande -->
        <div class="w-1/2 p-4 bg-white rounded-lg shadow-xl pb-6">
          <h2 class="text-sm sm:text-base lg:text-xl font-semibold mb-20">
            Implementação por Tipo de Controle
          </h2>
          <ChartsBar
            class="text-sm sm:text-base lg:text-lg"
            v-if="computedProps.temEmpresaID"
            v-bind="computedProps"
          />
        </div>
        <!-- 4 Gráficos de Barra Pequenos -->
        <div class="grid grid-cols-2 grid-rows-2 gap-2 w-1/2">
          <div
            v-for="(title, index) in [
              'Defesa',
              'Resiliência',
              'Governança e Ecossistema',
              'Proteção',
            ]"
            :key="index"
            class="p-4 bg-white rounded-lg shadow-xl flex flex-col items-center justify-center"
          >
            <h2 class="text-xs font-semibold">{{ title }}</h2>
            <ChartsBar
              class="w-full h-40"
              v-if="computedProps.temEmpresaID"
              v-bind="computedProps"
            />
          </div>
        </div>
      </div>
      <!-- Gráfico Radar -->
      <div class="chart-container p-4 col-span-1 lg:col-span-3 mt-2">
        <h2 class="text-sm sm:text-base lg:text-xl font-semibold mb-2">
          Avaliação de Segurança (Gráfico Radar)
        </h2>
        <ChartsRadar v-if="computedProps.temEmpresaID" v-bind="computedProps" />
      </div>
    </div>
  </div>
</template>

<script>
import ChartsBar from '@/components/charts/Bar.vue'
import ChartsRadar from '@/components/charts/Radar.vue'
import AdminCef from '@/components/dashboard/management/BusinessManagement.vue'
import AdminGcsA from '@/components/dashboard/management/ControlManagement.vue'
import Card from '@/components/ui/cards/CardCategorization.vue'
import Header from '@/components/layout/Header.vue'

import { getControllersCount } from '@/services/security-controls/api.controllers'

export default {
  name: 'AdminDashboard',
  components: {
    ChartsBar,
    ChartsRadar,
    Header,
    Card,
    AdminCef,
    AdminGcsA,
  },
  data() {
    return {
      showCadastro: false,
      showCadastroControles: false,
      controllersCount: 0,
      selectedCompany: {
        _id: '',
        EmpresaID: '',
        NomeEmpresa: '',
        totalControlesPorEmpresa: 0,
        QtdControlesImplementados: 0,
        QtdControlesParcial: 0,
        QtdControlesNaoImplementados: 0,
        NivelMaturidade: 0,
      },
    }
  },
  computed: {
    computedProps() {
      const EmpresaID = this.selectedCompany?._id
      const totalControles = Number(this.controllersCount) || 0
      const controleImplementado =
        Number(this.selectedCompany?.OrganizationalControlImplemented) || 0
      const controleParcial =
        Number(
          this.selectedCompany?.OrganizationalControlPartiallyImplemented
        ) || 0
      const controleNaoImplementado = Number(
        this.selectedCompany?.OrganizationalControlNotImplemented
      )
      const controleNaoAplicavel = Number(
        this.selectedCompany?.OrganizationalControlNotApplicable
      )
      const nivelMaturidade = Number(this.selectedCompany?.NivelMaturidade) || 0

      return {
        totalControles,
        controleImplementado,
        controleParcial,
        controleNaoImplementado,
        controleNaoAplicavel,
        nivelMaturidade,
        temEmpresaID: !!EmpresaID,
      }
    },

    totalControlesPorEmpresa() {
      return (
        this.selectedCompany.QtdControlesImplementados +
        this.selectedCompany.QtdControlesParcial +
        this.selectedCompany.QtdControlesNaoImplementados
      )
    },
  },
  methods: {
    async updateControllersCount() {
      try {
        const response = await getControllersCount()
        this.controllersCount = response.count
      } catch (error) {
        console.error('Erro ao buscar a contagem de controles:', error)
      }
    },
    handleCompanySelected(company) {
      this.selectedCompany = { ...company }
    },
    toggleCadastro() {
      this.showCadastro = !this.showCadastro
    },
    toggleCadastroControles() {
      this.showCadastroControles = !this.showCadastroControles
    },
    handleUserClick() {
      this.updateControllersCount()
    },
  },
  mounted() {
    // Atualiza os dados ao carregar a página
    this.updateControllersCount()

    // Adiciona o evento de clique para atualizar sempre que o usuário clicar
    document.addEventListener('click', this.handleUserClick)
  },
  beforeUnmount() {
    // Remove o evento de clique ao destruir o componente para evitar vazamento de memória
    document.removeEventListener('click', this.handleUserClick)
  },
}
</script>

<style scoped>
/* Estilos para os gráficos */
.chart-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: #000;
}

@media (min-width: 640px) {
  .chart-container {
    height: auto;
  }
}

@media (min-width: 1024px) {
  .chart-container {
    height: auto;
  }
}

/* Estilos adicionais para tabela */
.table-container,
.table-container th,
.table-container td {
  flex: 1;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: #000;
}

.text-white {
  color: #f5f5f5;
}

.graph-container {
  display: flex;
  gap: 36px;
  justify-content: space-between;
}

.chart-box {
  flex: 1;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.chart-box h2 {
  text-align: center;
  margin-bottom: 10px;
}
</style>
